export const CIPTextReplacements = {
    "Bond": "Bond 2016",
    "CIP": "Capital Improvement Plan",
    "Helene": "Helene Recovery",
  };